import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";

import { FormControl, FormGroup, Validators } from "@angular/forms";
import { BehaviorSubject, Observable, combineLatest, map, startWith, switchMap } from "rxjs";
import { IEmployeeRole } from '../../employee/employee-roles';
import { EmployeeRoleStoreService } from 'src/app/employee/storages/employee-role-store.service';
import { Employee, IEmployee, IEmployeeCreateRequest, IEmployeeRequest } from 'src/app/employee/employee';
import { DepartementStoreService } from 'src/app/setting/services/departement-store.service';
import { IDepartment } from 'src/app/setting/models/departement';
import { AppStateInterface } from 'src/app/stores/global/appState.interface';
import { Store, select } from '@ngrx/store';
import { activeEmployeesSelector, deleteEmployee, employeesSelector, getEmployees } from 'src/app/stores/global/employees/employees.store';

@Component({
    selector: 'app-employees',
    templateUrl: './employees.component.html',
    styleUrls: ['./employees.component.css'],
    standalone: false
})
export class EmployeesComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private departementStore: DepartementStoreService,
    private employeeRoleStore: EmployeeRoleStoreService,
    private store : Store<AppStateInterface>,
  ) { 
  }


  departements$: Observable<IDepartment[]> =
    this.departementStore.departements$;

  employeeRoles$: Observable<IEmployeeRole[]> =
    this.employeeRoleStore.employeeRoles$;

  public editDataItem: Employee;
  public isNew = false;
  showDeleteModal : string;

  onlyActiveEmployeesSub$ = new BehaviorSubject<boolean>(true);

  vm$ = combineLatest([
    this.onlyActiveEmployeesSub$.pipe(
      switchMap(onlyActiveEmployeesSub => onlyActiveEmployeesSub ? this.store.pipe(select(activeEmployeesSelector)) : this.store.pipe(select(employeesSelector)))),
    this.departementStore.departements$,
    this.employeeRoleStore.employeeRoles$,
    this.onlyActiveEmployeesSub$
  ]).pipe(
    map(([
      employees,
      departements,
      employeeRoles,
      onlyActiveEmployeesSub
    ]) => ({
      employees,
      departements,
      employeeRoles,
      onlyActiveEmployeesSub
    }))
  );

  ngOnInit(): void {}

  onDelete(id: string) {
    this.store.dispatch(deleteEmployee({ id: id }));
    this.showDeleteModal = null;
  }

  public editEmployee(employee: IEmployee) {
    this.router.navigate(['settings/employee/', employee.id]);
  }

  public createEmployee() {
    this.router.navigate(['settings/employee/']);
    this.isNew = true;
  }
}
